export default __webpack_public_path__ + "static/media/hht1_ep10_timeline_q04_b.4ac4985a.png";